import React, { useState } from 'react';
import JSONInput from "react-json-ide";
import locale from "react-json-ide/locale/en";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { DialogActions } from "@material-ui/core";
import Button from "../Button";

const CreditReportPopup = ({ creditReport }) => {

    const [open, setOpen] = useState(false);
    const toggleOpen = () => {
        setOpen(!open);
    };

    return (
        <div>
            <Button
                color="secondary"
                variant="contained"
                onClick={toggleOpen}>
                View Credit Report
            </Button>
            <Dialog
                open={open}
                contentlabel="Credit Report"
                maxWidth={"md"}
            >
                <DialogTitle>
                    <Typography color="secondary" variant="h6">
                        Credit Report
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    {creditReport ?
                        <JSONInput
                            id="creditReportData"
                            placeholder={creditReport}
                            locale={locale}
                            height="500px"
                            width="100%"
                            viewOnly
                        /> : "No credit report available."}
                    <DialogActions>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={toggleOpen}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default CreditReportPopup;